import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Toaster } from '@lotto/ui';

import { ThemeApplier, ThemeProvider } from '@/domains/theme';
import { config } from '@/config';

function RootComponent() {
  return (
    <ThemeProvider>
      <ThemeApplier />
      <div className="min-h-screen bg-background bg-glass-mesh text-foreground">
        <Toaster />
        <Outlet />
        {config.isDev && (
          <>
            <TanStackRouterDevtools position="bottom-right" />
            <ReactQueryDevtools buttonPosition="bottom-left" />
          </>
        )}
      </div>
    </ThemeProvider>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
});
